export default "__VITE_ASSET__C5b8xWZn__"